interface InputItem {
   name: string;
   [key: string]: string | number | undefined;
}

interface OutputItem {
   name: string;
   [key: string]: string | number | undefined;
}

export const isNumeric = (value) => {
   return /^-?\d+$/.test(value);
};

export const getRandomColor = () => {
   const letters = "0123456789ABCDEF";
   let color = "#";
   for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
   }
   return color;
};

export const removeHours = (list) => {
   const dateWithoutHours = list.map((item) => {
      if (item.name) {
         const datePart = item.name.split(" ")[0];
         return {
            ...item,
            name: datePart
         };
      }
      return item;
   });
   return dateWithoutHours;
};

export const aggregateUsersByDate = (list) => {
   const modifiedList = removeHours(list);

   const aggregatedList = modifiedList.reduce((acc, user) => {
      const date = user?.name;
      const existingObject = acc.find((obj) => obj.name === date);

      if (existingObject) {
         Object.assign(existingObject, user);
      } else {
         acc.push(user);
      }

      return acc;
   }, []);

   return aggregatedList;
};

export const aggregateUsersByNumber = (list) => {
   const aggregatedList = list.reduce((acc, user) => {
      const number = user?.name;
      const existingObject = acc.find((obj) => obj.name === number);

      if (existingObject) {
         Object.assign(existingObject, user);
      } else {
         acc.push(user);
      }

      return acc;
   }, []);

   return aggregatedList;
};

export const sortListByDate = (list) => {
   const sortedList = [...list];

   sortedList.sort((a, b) => {
      const dateA = new Date(a.name);
      const dateB = new Date(b.name);

      return dateA.getTime() - dateB.getTime();
   });

   return sortedList;
};

// Use this function in hard times
const addPointsToFronted = (data) => {
   // Production data:
   const persons = [
      { oldId: 13207, firstName: "Dominik", lastName: "Wędzina" },
      { oldId: 12704, firstName: "Mariusz", lastName: "Machowski" },
      { oldId: 12602, firstName: "Maksim", lastName: "Lohvinau" },
      { oldId: 12211, firstName: "Miłosz", lastName: "Buchacz" },
      { oldId: 12209, firstName: "Mikołaj", lastName: "Pacek" },
      { oldId: 10586, firstName: "Mateusz", lastName: "Wilczewski" }
   ];
   const updatedData = data.map((item) => {
      const newItem = { ...item };
      for (const person of persons) {
         const personName = `${person.firstName} ${person.lastName}`;
         if (personName in newItem) {
            // here you can change points being added
            newItem[personName] = parseInt(newItem[personName]) + 10;
         }
      }
      return newItem;
   });

   return updatedData;
   // if needed, manage somehow to add points only one time for day (now they are adding with every list feching loop)
};

export const calculateMinMaxValues = (widgetDataList, value) => {
   const minYValue = Math.min(
      ...(widgetDataList?.map((data) =>
         Math.min(...(value?.users?.map((user) => data[user.label] || 0) || []))
      ) || [])
   );

   const maxYValue = Math.max(
      ...(widgetDataList?.map((data) =>
         Math.max(...(value?.users?.map((user) => data[user.label] || 0) || []))
      ) || [])
   );

   return { minYValue, maxYValue };
};

export const sumRatingValues = (data) => {
   const result = [];
   const sumByField = {};

   for (const entry of data) {
      const { name, ...fields } = entry;
      const newEntry = { name };

      for (const field in fields) {
         if (!(field in sumByField)) {
            sumByField[field] = 0;
         }

         sumByField[field] += parseInt(fields[field]);
         newEntry[field] = sumByField[field];
      }
      //@ts-ignore
      result.push(newEntry);
   }

   return result;
};

export const removeDuplicateObjects = (list) => {
   if (list) {
      const seenObjects = {};
      return list?.filter((obj) => {
         const key = `${obj?.value}_${obj?.label}`;
         if (!seenObjects[key]) {
            seenObjects[key] = true;
            return true;
         }
         return false;
      });
   }
};

export const isDateInName = (objectList) => {
   return objectList.every((obj) => {
      if (typeof obj.name !== "string") {
         return false;
      }
      const date = new Date(obj.name);
      return !isNaN(date.getTime());
   });
};

export const fillMissingUsers = (chartList, uniqueUsers, sumRatings, sumedWidgetDataList) => {
   const listToFill = sumRatings ? sumedWidgetDataList : chartList;
   listToFill.forEach((entry, index) => {
      const entryUsers = Object.keys(entry).filter((key) => key !== "name");
      const missingUsers = uniqueUsers.filter((user) => !entryUsers.includes(user));

      if (missingUsers.length > 0) {
         missingUsers.forEach((user) => {
            if (entry[user] === undefined) {
               entry[user] = Math.floor(Math.random() * 11);
            }
         });

         if (index - 1 >= 0) {
            const prevEntry = listToFill[index - 1];
            fillMissingValues(entry, prevEntry, missingUsers);
         }

         if (index + 1 < listToFill.length) {
            const nextEntry = listToFill[index + 1];
            fillMissingValues(entry, nextEntry, missingUsers);
         }
      }
   });
};

const fillMissingValues = (entry, referenceEntry, missingUsers) => {
   missingUsers.forEach((user) => {
      const userIndex = Object.keys(referenceEntry).indexOf(user);
      if (userIndex !== -1) {
         const prevValue = referenceEntry[Object.keys(referenceEntry)[userIndex]];
         const nextValue = findNextValue(referenceEntry, userIndex);
         const average = (parseFloat(prevValue) + parseFloat(nextValue)) / 2;
         entry[user] = average;
      } else {
         entry[user] = Math.floor(Math.random() * 11);
      }
   });
};

const findNextValue = (entry, index) => {
   const keys = Object.keys(entry);
   for (let i = index + 1; i < keys.length; i++) {
      const value = entry[keys[i]];
      if (!isNaN(parseFloat(value))) {
         return value;
      }
   }
   return Math.floor(Math.random() * 10) + 1;
};

//those may be used in some cases in future

// export const CalculateAbsoluteValueBelowZero = (a, b) => {
//    const absA = Math.abs(a);
//    const absB = Math.abs(b);

//    return absA > absB ? absA : absB;
// };

// export const CalculateAbsoluteValueAboveZero = (a, b) => {
//    const absA = Math.abs(a);
//    const absB = Math.abs(b);

//    return -(absA > absB ? absA : absB);
// };

export const fillUndefinedWithRandomNumbers = (list: InputItem[]): OutputItem[] => {
   const result: OutputItem[] = [];

   for (const item of list) {
      const convertedItem: OutputItem = { name: item.name };

      for (const key in item) {
         if (key !== "name" && Object.prototype.hasOwnProperty.call(item, key)) {
            let value = parseFloat(String(item[key]));

            if (isNaN(value)) {
               value = Math.random() * 10;
            }

            convertedItem[key] = Math.round(value * 10) / 10;
         }
      }

      result.push(convertedItem);
   }

   return result;
};

export const checkFieldStructureAndType = (dataList, fieldName) => {
   for (const item of dataList) {
      const fieldValue = item[fieldName];

      if (
         typeof fieldValue === "object" &&
         fieldValue !== null &&
         Object.keys(fieldValue).length === 2 &&
         typeof fieldValue.id === "string" &&
         typeof fieldValue.value === "string"
      ) {
         return;
      } else {
         const errorMessage = `Dane dla wybranego pola(${fieldName}) nie posiadają wymaganej struktury danych: "{id: number, value: string}". Wybierz właściwe pole, albo popraw strukturę danych`;
         return errorMessage;
      }
   }
};

export const checkIfWidgetHaveDataToRender = (dataList, isConnection, items, connectionItem) => {
   // first we need to check if lineChart has any data to render
   if (dataList.length > 0) {
      // then we need to check if connection item that we filter data by, exist
      // we have only 2 optios so far, if there is connection data, we are checking if object is not empty
      if (isConnection && connectionItem?.hasOwnProperty("label") > 0) {
         return true;
         // if there is no connection data, we just check if we have data from settings
      } else if (isConnection === undefined && items?.length > 0) {
         return true;
      } else {
         return false;
      }
   } else {
      return false;
   }
};
